/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import Icon from '../Icon'

interface ScheduleEmptyStateProps {
  onGenerateSchedule: () => void
}

const titleFont = isCanlan
  ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif'
  : 'Barlow Condensed, Arial, Helvetica, sans-serif'

const bodyFont = isCanlan
  ? 'Gilroy, Arial, Helvetica, sans-serif'
  : 'Inter, Arial, Helvetica, sans-serif'

const ScheduleEmptyState = ({
  onGenerateSchedule,
}: ScheduleEmptyStateProps) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
        padding: 24px 88px;
        min-height: 400px;
      `}
    >
      <div
        css={css`
          width: 194px;
          height: 172px;
          background: linear-gradient(
            135deg,
            ${colors.PRIMARY}33 0%,
            ${colors.PRIMARY}1a 100%
          );
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          overflow: hidden;

          &::before {
            content: '🎉';
            font-size: 80px;
            position: absolute;
          }
        `}
        aria-label='Celebration'
      />

      <h1
        css={css`
          font-family: ${titleFont};
          font-size: 28px;
          font-weight: 600;
          line-height: 33.6px;
          letter-spacing: 0;
          color: ${colors.NEUTRAL_0};
          margin: 0;
          text-align: center;
        `}
      >
        Your Competition is Ready!
      </h1>

      <p
        css={css`
          font-family: ${bodyFont};
          font-size: 14px;
          font-weight: 400;
          line-height: 20.3px;
          letter-spacing: 0;
          color: ${colors.NEUTRAL_50};
          margin: 0;
          text-align: center;
          max-width: 400px;
        `}
      >
        Generate your schedule now.
      </p>

      <button
        onClick={onGenerateSchedule}
        type='button'
        css={css`
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 8px 16px;
          background-color: ${colors.PRIMARY};
          border: none;
          border-radius: 8px;
          cursor: pointer;
          margin-top: 8px;
          font-family: ${bodyFont};
          font-size: 18px;
          font-weight: 500;
          line-height: 26.1px;
          color: ${colors.SECONDARY_300};

          &:hover {
            background-color: ${colors.PRIMARY_200};
          }
        `}
      >
        <Icon name='magic' fontSize={18} color={colors.SECONDARY_300} />
        Generate Schedule
      </button>
    </div>
  )
}

export default ScheduleEmptyState
